<script setup lang="ts">

import { NConfigProvider, NMessageProvider } from 'naive-ui';

useHead({
  title: 'HopeAI - The AI-Native Workspace for Drug Development',
  meta: [
    // 系统和浏览器相关的 meta 标签（非 SEO）
    { name: 'theme-color', content: '#0D121F' },
    { name: 'msapplication-navbutton-color', content: '#0D121F' },
    { name: 'author', content: 'HopeAI' },
    { name: 'viewport', content: 'width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no' },
    { name: 'apple-mobile-web-app-title', content: 'HopeAI' },
    { name: 'application-name', content: 'HopeAI' },
    { name: 'msapplication-tap-highlight', content: 'no' },
    { name: 'msapplication-TileColor', content: '#603cba' },
    { name: 'msapplication-TileImage', content: '/mstile-144x144.png' },
    // Twitter App 相关标签
    { name: 'twitter:app:name:iphone', content: 'HopeAI' },
    { name: 'twitter:app:name:ipad', content: 'HopeAI' },
    { name: 'twitter:app:name:googleplay', content: 'HopeAI' },
    // SEO 关键词
    { name: 'keywords', content: 'HopeAI, Hope AI, clinical trials, AI, Copilot, adaptive design, Will Ma, Feifang Hu' },
    // Open Graph site_name（通用属性，不会被页面覆盖）
    { name: 'og:site_name', content: 'HopeAI', property: 'og:site_name' },
  ],
  link: [
    { rel: "apple-touch-icon", sizes: "180x180", href: "/apple-touch-icon.png" },
    { rel: "icon", type: "image/png", sizes: "32x32", href: "/favicon-32x32.png" },
    { rel: "icon", type: "image/png", sizes: "16x16", href: "/favicon-16x16.png" },
    { rel: "manifest", href: "/site.webmanifest" },
    { rel: "mask-icon", href: "/safari-pinned-tab.svg", color: "#000000" },
    {
      rel: 'alternate', href: 'https://hopeai.co', hreflang: 'x-default'
    },
    {
      rel: 'alternate', href: 'https://hopeai.co', hreflang: 'en'
    },
    {
      rel: 'canonical', href: 'https://hopeai.co'
    },
    {
      rel: 'preconnect', href: 'https://hopeai.co'
    },
    {
      rel: 'preconnect', href: 'https://hopeai.co', crossorigin: 'anonymous'
    },
    {

    }
  ],
  script: [
    {
      type: 'application/ld+json',
      innerHTML: `
      { 
        "@context": "https://schema.org/", 
        "@type": "Organization", 
        "url": "https://hopeai.co/", 
        "logo":"https://hopeai.oss-us-east-1.aliyuncs.com/img/logo.jpg"     
      }
      `,
      hid: 'ldjson-schema',
    }
  ]
})

useSeoMeta({
  title: 'HopeAI - The AI-Native Workspace for Drug Development',
  description: 'HopeAI brings together specialized AI agents, proprietary data, and validated workflows to transform how new medicines are developed.',
  ogDescription: 'HopeAI brings together specialized AI agents, proprietary data, and validated workflows to transform how new medicines are developed.',
  ogImage: 'https://hopeai.oss-us-east-1.aliyuncs.com/img/hopeai.png',
  ogTitle: 'HopeAI - The AI-Native Workspace for Drug Development',
  ogUrl: 'https://hopeai.co',
  ogType: 'website',
  ogLocale: 'en_US',
  twitterTitle: 'HopeAI - The AI-Native Workspace for Drug Development',
  twitterDescription: 'HopeAI brings together specialized AI agents, proprietary data, and validated workflows to transform how new medicines are developed.',
  twitterImage: 'https://hopeai.oss-us-east-1.aliyuncs.com/img/hopeai.png',
  twitterCard: 'summary_large_image',
})

const themeOverrides = {
  "common": {
    "borderRadius": "6px",
    "borderRadiusSmall": "2px",
    "primaryColor": "#7A47B9FF",
    "primaryColorHover": "#7C46BFFF",
    "primaryColorPressed": "#7A47B9FF",
    "primaryColorSuppl": "#7A47B9FF"
  }
}

</script>

<template>
  <div class="hopeai_home">
    <n-config-provider :theme-overrides="themeOverrides">
      <n-message-provider>
        <NuxtPage />
      </n-message-provider>
    </n-config-provider>
  </div>
</template>

<style lang="scss">
body {
  width: 100%;
  min-height: 100vh;
  background: #0D121F;
  transition: color 0.5s, background-color 0.5s;
  line-height: 1.6;
  font-family:
    -apple-system, BlinkMacSystemFont, segoe ui, Roboto,
    Helvetica Neue, Helvetica, Arial, sans-serif;
  font-size: 14px;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
}

* {
  padding: 0;
  margin: 0;
}

.hopeai_home {
  width: 100%;
  height: 100vh;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
}
</style>